package com.writerslab.office

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

enum class Page { STATS, ANALYTICS, FINANCE, CODES, REPORTS, BLOG }

@Composable
fun App(initialPage: Page = Page.STATS) {
    var page by remember { mutableStateOf(initialPage) }

    Div({
        style {
            backgroundColor(Color(C.Bg))
            color(Color(C.OnSurface))
            property("min-height", "100vh")
            property("display", "flex")
            property("flex-direction", "column")
        }
    }) {
        // Nav bar
        Div({
            style {
                backgroundColor(Color(C.Surface))
                property("border-bottom", "1px solid ${C.Border}")
                padding(0.px, 24.px)
                property("display", "flex")
                property("align-items", "center")
                property("gap", "4px")
                height(52.px)
            }
        }) {
            Span({
                style {
                    color(Color(C.Primary))
                    property("font-weight", "700")
                    fontSize(14.px)
                    property("margin-right", "16px")
                    property("white-space", "nowrap")
                }
            }) { Text("WL Office") }

            NavTab("Статистика", page == Page.STATS) { page = Page.STATS }
            NavTab("Аналитика", page == Page.ANALYTICS) { page = Page.ANALYTICS }
            NavTab("Финансы", page == Page.FINANCE) { page = Page.FINANCE }
            NavTab("Коды", page == Page.CODES) { page = Page.CODES }
            NavTab("Отчёты", page == Page.REPORTS) { page = Page.REPORTS }
            NavTab("Блог", page == Page.BLOG) { page = Page.BLOG }

            Div({ style { property("flex", "1") } })

            Button({
                style {
                    btn(C.SurfaceHigh, C.Muted)
                    property("border", "1px solid ${C.Border}")
                    fontSize(12.px)
                }
                onClick { Auth.logout() }
            }) { Text("Выйти") }
        }

        // Content. The blog editor is a two-column (edit + preview) layout,
        // so it gets a wider cap than the data pages.
        Div({
            style {
                property("flex", "1")
                padding(0.px, 24.px)
                property("max-width", if (page == Page.BLOG) "1680px" else "1200px")
                property("width", "100%")
                property("box-sizing", "border-box")
            }
        }) {
            when (page) {
                Page.STATS -> StatsPage()
                Page.ANALYTICS -> AnalyticsPage()
                Page.FINANCE -> FinancePage()
                Page.CODES -> CodesPage()
                Page.REPORTS -> ReportsPage()
                Page.BLOG -> BlogPage()
            }
        }
    }
}

@Composable
private fun NavTab(label: String, active: Boolean, onClick: () -> Unit) {
    Div({
        style {
            padding(0.px, 14.px)
            height(52.px)
            property("display", "flex")
            property("align-items", "center")
            cursor("pointer")
            fontSize(14.px)
            if (active) {
                color(Color(C.Primary))
                property("border-bottom", "2px solid ${C.Primary}")
            } else {
                color(Color(C.Muted))
                property("border-bottom", "2px solid transparent")
            }
        }
        onClick { onClick() }
    }) { Text(label) }
}
